/**
 * Who may reach the Referral / "Earnings Program" dashboard while the programme
 * is SUSPENDED.
 *
 * Gordon, 2026-09-03: "people ALREADY in the Referral Program must keep access
 * to their Referral Program page on Staging and Production while the program is
 * suspended for new sign-ups."
 *
 * The suspension (`REFERRAL_PROGRAM_SUSPENDED`, constants/featureFlags.js) was
 * built as a blanket kill-switch: every surface that could show the programme
 * checked the flag alone, so an already-enrolled member lost their dashboard,
 * earnings, payouts and account balance along with the marketing. Suspension is
 * meant to close the door to NEW members, not to evict the ones already inside.
 *
 * `isInReferralProgram` is the backend's own enrollment signal — `UserSettings.
 * is_in_referral_program`, surfaced as `extra_data.in_ref_program` on
 * POST /subscription/permissions/ and read through
 * `useIfUserEligible(FEATURES.REFFERAL_PROGRAM)`. It is `false` for everyone who
 * never completed enrollment, so this carve-out cannot re-open a sign-up path:
 * a non-member evaluates exactly as they did before it existed.
 *
 * One rule in one place so the page's tab map and the nav entry that points at
 * it can never drift apart.
 */
export function canAccessReferralDashboard({ suspended, isInReferralProgram }) {
  return !suspended || Boolean(isInReferralProgram);
}

export default canAccessReferralDashboard;
